import { createReducer } from 'redux-act';
import * as P from 'plow-js';
// feature mail-sending
import * as A from './actions';
//////////////////////////////////////////////////

export const initialState = {
  contactList: null,
  mailSend: {
    to: [''],
    subject: '',
  },
};

const getMailSendingSuccess = (state, data) => (
  P.$set('mailSend', data, state)
);

const createMailSendingSuccess = (state, data) => (
  P.$set('mailSend', data, state)
);

const updateMailSendingSuccess = (state, data) => (
  P.$set('mailSend', data, state)
);

const receivedContactListSuccess = (state, data) => (
  P.$set('contactList', data, state)
);

export default createReducer({
  [A.getMailSendingSuccess]: getMailSendingSuccess,
  [A.createMailSendingSuccess]: createMailSendingSuccess,
  [A.updateMailSendingSuccess]: updateMailSendingSuccess,
  [A.receivedContactListSuccess]: receivedContactListSuccess,
}, initialState);
